/**
 * Piletilevi Sales terminal services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * - PENDING newly added bank account IBAN which needs to be verified - ACTIVE verified and active bank account - ARCHIVED previously active bank account which was deactivated by activating new one - INVALID previously pending bank accounts that verification failed or user added new account and previous was not verified at all 
 */
export type BankAccountStatus = 'PENDING' | 'ACTIVE' | 'ARCHIVED' | 'INVALID';

export const BankAccountStatus = {
    Pending: 'PENDING' as BankAccountStatus,
    Active: 'ACTIVE' as BankAccountStatus,
    Archived: 'ARCHIVED' as BankAccountStatus,
    Invalid: 'INVALID' as BankAccountStatus
};

